import React from "react";
import { StyleSheet, useWindowDimensions } from "react-native";
import { palette, spacing } from "../../styles";
import Block from "../Block";
import Divider from "../Divider";
import LinePlaceholder from "../LinePlaceholder";

type Props = {
  marginBottom?: number;
  marginTop?: number;
  width?: number;
};

const ServiceCardPlaceholder = ({ marginBottom = 0, marginTop = 0 }: Props) => {
  const { width: screenWidth } = useWindowDimensions();

  const width = screenWidth > 700 ? 626 : screenWidth - 72;

  return (
    <Block marginTop={marginTop} marginBottom={marginBottom} style={styles.container}>
      <Block paddingHorizontal={2} paddingTop={1.5}>
        <Block row justifySpace alignCenter>
          <Block>
            <LinePlaceholder borderRadius={1} width={8} height={2} />
            <LinePlaceholder borderRadius={1} width={22} height={3} />
          </Block>
          <LinePlaceholder borderRadius={1} width={11} height={3} />
        </Block>
      </Block>

      <Divider color={palette.secondary.grey} />

      <Block paddingHorizontal={2} paddingBottom={2}>
        <Block row justifySpace marginTop={1}>
          <LinePlaceholder borderRadius={1} width={26} height={3} />
          <LinePlaceholder borderRadius={1} width={8} height={2.5} />
        </Block>
        <LinePlaceholder borderRadius={1} width={12} height={2} />

        <LinePlaceholder borderRadius={1} width={15} height={3} marginTop={2} />

        <LinePlaceholder borderRadius={1} width={width / 8} height={18} marginTop={2} />
      </Block>
    </Block>
  );
};

export default React.memo(ServiceCardPlaceholder);

const styles = StyleSheet.create({
  container: {
    borderColor: palette.secondary.grey,
    borderRadius: spacing.radius * 2,
    borderWidth: spacing.border,
  },
});
